
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skiareal",
      function () {
        return require("private-next-pages/skiareal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skiareal"])
      });
    }
  